import styled from 'styled-components'
import {deviceMax} from '../../theme/breakpoints'
import pxToRem from '../../utils/pxToRem'
import Slider from 'react-slick'

export const StyledBar = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  min-height: ${pxToRem(150)};
  background-color: ${({theme}) => theme.colors.unique.black};
  overflow-x: auto;
  overflow-y: hidden;
  padding: ${({$centered}) => ($centered ? `0` : `0 ${pxToRem(10)} 0 0`)};

  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
`

export const StyledBarContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  width: 100%;
  max-width: ${pxToRem(1198)};
  gap: ${pxToRem(20)};
  padding: ${pxToRem(10)};
  margin: 0 auto;
  @media ${deviceMax.mobileL} {
    gap: 20%;
  }
`

export const TextKeys = styled.span`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: flex !important;
  font-size: ${({theme}) => theme.fonts.sizes.base};
  font-weight: ${({theme}) => theme.fonts.sizes.medium};

  &:hover {
    cursor: ${({$hovered}) => ($hovered ? 'pointer' : 'default')};
  }
`

export const ValueKey = styled.p`
  font-size: ${({theme}) => theme.fonts.sizes.keys};
  line-height: ${({theme}) => theme.fonts.lineHeight.keys};
  font-weight: ${({theme}) => theme.fonts.weight.medium};
  color: ${({theme}) => theme.colors.unique.white};
  text-align: center;

`

export const TextKey = styled.div`
  display: inline-block;
  max-width: ${pxToRem(184)};
  font-size: ${({theme}) => theme.fonts.sizes.base};
  font-weight: ${({theme}) => theme.fonts.weight.medium};
  color: ${({theme}) => theme.colors.unique.white};
  text-align: center;
  white-space: break-spaces;
`

export const StyledSlider = styled(Slider)`
  width: 100%;

  .slick-track {
    justify-content: center;
    align-items: center;
    display: flex;
  }
`
